
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-59438b56&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Testimonial.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Testimonial.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-59438b56!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Testimonial.vue"),
  /* scopeId */
  "data-v-59438b56",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/Testimonial.vue
// module id = 475
// module chunks = 1